import { ServiceFunction } from "utils/index";
import BaseService from "../base";
import ApplyPMPExcludedStepService from "./applyPMPExcludedStepService";
import { IApplyPmpExcludedEditPayload, IApplyPmpExcludedEditResponse } from "./types";

class ApplyPMPExcludedService extends BaseService {
  getApplyPmpExcludedStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ApplyPMPExcludedStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  applyPMPExcludedTriggerStepAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("applyPMPExcludedTriggerStepAction", para, success, error);
  };

  checkApplyPmpExcludedEdit: ServiceFunction<
    IApplyPmpExcludedEditPayload,
    IApplyPmpExcludedEditResponse
  > = (para, success, error) => {
    // @ts-ignore
    this.sendRequest("checkApplyPmpExcludedEdit", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const applyPMPExcludedService = new ApplyPMPExcludedService();

export default applyPMPExcludedService;
